export const LEGACY_PURCHASE_REQUISITION_TYPE_IDS = [5, 28, 33];
export const LEGACY_PURCHASE_REQUISITION_TYPE_CODES = ['PRT0005', 'PRT0028', 'NEW'];

const normalizeCode = (value) => String(value || '').trim().toUpperCase();
const normalizeId = (value) => Number(value || 0);

export const isLegacyPurchaseRequisitionType = (item = {}) => {
  const id =
    normalizeId(item?.purchase_requisition_type_id) ||
    normalizeId(item?.PURCHASEREQUISITIONTYPEID) ||
    normalizeId(item?.id) ||
    normalizeId(item?.value);

  const code = normalizeCode(
    item?.purchase_requisition_type_code ||
      item?.PURCHASEREQUISITIONTYPECODE ||
      item?.code ||
      item?.purchaseRequisitionTypeCode,
  );

  return LEGACY_PURCHASE_REQUISITION_TYPE_IDS.includes(id) || LEGACY_PURCHASE_REQUISITION_TYPE_CODES.includes(code);
};

export const filterVisiblePurchaseRequisitionTypes = (items = []) =>
  (Array.isArray(items) ? items : []).filter((item) => !isLegacyPurchaseRequisitionType(item));
